import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListProductLineActions } from "store/ducks/settings/product-line";
import { IProductLine } from "interfaces/product-line";

export function* listProductLineRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/product-lines?${queryString}`);

    let comboOptions = [];
    if (data.types && data.types.length > 0) {
      comboOptions = data.types.map((plant: IProductLine) => ({
        value: plant.id,
        label: plant.name,
      }));
    } else if (data.length > 0) {
      comboOptions = data.map((plant: IProductLine) => ({
        value: plant.id,
        label: plant.name,
      }));
    }
    yield put(ListProductLineActions.success(comboOptions));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListProductLineActions.failure(errorMessage));
  }
}
